var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"msg"},[_vm._v("["+_vm._s(_vm.content.text.split("#")[2])+"]")]),_c('span',{staticClass:"chat-time"},[_vm._v(_vm._s(_vm._f("formatTimeHM")(_vm.time)))])])}
var staticRenderFns = []

export { render, staticRenderFns }